import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn} from '@angular/forms';
import { Observable, timer, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { InvalidImportIdException } from './exceptions/invalid-import-id.model';
import { CloneService } from '../Applications/Airsweb/Services';

@Injectable({
    providedIn: 'root'
})
export class ImportIdValidator {
    constructor(private cloneService: CloneService){}

    getValidator(): AsyncValidatorFn {
        const debounceTimeMs = 200;
        return (control: AbstractControl) => timer(debounceTimeMs).pipe(switchMap(() => this.checkImportId(control.value)));
    }

    private checkImportId(importId: string): Observable<InvalidImportIdException> {
        return this.cloneService.checkImportIdExists(importId).pipe(
            map((doesExist) => doesExist ? null : new InvalidImportIdException())
        );
    }
}
